import { computed } from '@angular/core';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { ImageState } from './image.state';
import { StateFilter } from '../crud.state';
import { Image } from '../../models/image';

const filterItems = (items: Image[], filter: StateFilter, products = false) => {
  return items.filter(item => {
    const titleMatch = item.title
      .toLowerCase()
      .includes(filter.query.toLowerCase());

    const idMatch =
      !filter.ids ||
      filter.ids.length === 0 ||
      filter.ids.includes(item._id) ||
      filter.ids.includes(item._id);

    return titleMatch && idMatch;
  });
};

export function withImageSelectors() {
  return signalStoreFeature(
    {
      state: type<ImageState>(),
    },
    withComputed(({ items, filter, selection }) => ({
      count: computed(() => Object.keys(items()).length),
      asArray: computed(() => {
        return Object.values(items())
          .filter(image => image.commune !== null)
          .sort((a, b) => (a.title < b.title ? -1 : 1));
      }),
    }))
  );
}
